import styled from "styled-components"

const CardBar = styled.div<{ open: boolean }>`
  padding: ${(props) => `${props.theme.spacings.extreme} ${props.theme.spacings.extreme}`};
  background-color: ${(props) => props.theme.colors.white};
  border-radius: ${(props) => (props.open ? "24px 24px 0 0" : props.theme.borders.largeRadius)};
`

export default CardBar
